import React from 'react';

import { Typography } from '@material-ui/core';

import { CustomTextField } from '../CustomTextField';
import { PageLinksInputsContainer, TextFieldContainer } from './styles';

import propTypes from 'prop-types';

export function PageLinksInputs({
  contactEmail,
  setContactEmail,
  link1Title,
  setLink1Title,
  link1Url,
  setLink1Url,
  link2Title,
  setLink2Title,
  link2Url,
  setLink2Url,
}) {
  return (
    <PageLinksInputsContainer>
      <TextFieldContainer>
        <Typography style={{ fontSize: '12px', marginBottom: '5px' }}>
          Email ou link de contato
        </Typography>
        <CustomTextField
          value={contactEmail}
          setValue={setContactEmail}
          placeholder="email ou link"
        />
      </TextFieldContainer>
      <TextFieldContainer>
        <Typography style={{ fontSize: '12px', marginBottom: '5px' }}>
          Link personalizado 1
        </Typography>
        <CustomTextField
          value={link1Title}
          setValue={setLink1Title}
          placeholder="Título"
        />
        <CustomTextField
          value={link1Url}
          setValue={setLink1Url}
          placeholder="URL"
        />
      </TextFieldContainer>
      <TextFieldContainer>
        <Typography style={{ fontSize: '12px', marginBottom: '5px' }}>
          Link personalizado 2
        </Typography>
        <CustomTextField
          value={link2Title}
          setValue={setLink2Title}
          placeholder="Título"
        />
        <CustomTextField
          value={link2Url}
          setValue={setLink2Url}
          placeholder="URL"
        />
      </TextFieldContainer>
    </PageLinksInputsContainer>
  );
}

PageLinksInputs.propTypes = {
  contactEmail: propTypes.string,
  setContactEmail: propTypes.func,
  link1Title: propTypes.string,
  setLink1Title: propTypes.func,
  link1Url: propTypes.string,
  setLink1Url: propTypes.func,
  link2Title: propTypes.string,
  setLink2Title: propTypes.func,
  link2Url: propTypes.string,
  setLink2Url: propTypes.func,
};
